var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9ed32;\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.2,18.48c.96,0,1.78-.28,2.48-.84s1.04-1.37,1.04-2.42c0-.8-.28-1.49-.83-2.07s-1.3-.87-2.23-.87c-.63,0-1.16,.09-1.57,.27s-.74,.41-.98,.7-.47,.67-.68,1.12-.41,.89-.59,1.3c-.1,.22-.29,.39-.56,.52s-.58,.19-.94,.19c-.42,0-.8-.17-1.15-.51s-.52-.79-.52-1.35,.16-1.11,.49-1.71,.81-1.17,1.44-1.71,1.41-.98,2.35-1.3,1.98-.49,3.14-.49c1.01,0,1.93,.14,2.77,.41s1.56,.67,2.17,1.2,1.08,1.12,1.39,1.81,.47,1.43,.47,2.22c0,1.04-.23,1.94-.68,2.68s-1.1,1.47-1.95,2.18c.81,.44,1.5,.94,2.05,1.5s.98,1.19,1.26,1.87,.42,1.42,.42,2.21c0,.95-.19,1.87-.57,2.75s-.94,1.67-1.68,2.37-1.62,1.23-2.63,1.62-2.14,.59-3.37,.59-2.37-.22-3.36-.67-1.8-1.01-2.45-1.68-1.12-1.37-1.45-2.09-.49-1.31-.49-1.78c0-.6,.2-1.09,.59-1.46s.88-.55,1.46-.55c.29,0,.57,.09,.84,.26s.45,.38,.53,.62c.54,1.45,1.12,2.52,1.74,3.23s1.49,1.05,2.62,1.05c.65,0,1.27-.16,1.87-.48s1.09-.79,1.48-1.41,.59-1.35,.59-2.17c0-1.22-.33-2.17-1-2.87s-1.59-1.04-2.78-1.04c-.21,0-.53,.02-.97,.06s-.72,.06-.84,.06c-.57,0-1.02-.14-1.33-.43s-.47-.69-.47-1.2,.19-.9,.56-1.21,.93-.46,1.67-.46h.64Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT3);
export default __webpack_public_path__ + "static/media/T3.c55c681c22fbef11954771e57739bdde.svg";
export { ForwardRef as ReactComponent };